<template lang="pug">
  .module__main
    .module__title Список движений
    .module-content__container
      .filters__container
        .mode__container
          .filter__content
            el-select(v-model="mode" placeholder="Режим" @change="switchMode")
              el-option(label="Поступления" value="payins" key="mode-key-payins")
              el-option(label="Выводы" value="payouts" key="mode-key-payouts")
        .users__container
          .filter__content
            el-select(v-model="account_name" placeholder="Пользователь")
              el-option(v-for="current in names" :label="current" :value="current" :key="`filter-user-${current}`")
        .comment__container
          el-input(v-model="comment" placeholder="Комментарий")
        .date__container
          el-date-picker(
            v-model="date"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="-"
            start-placeholder="Начало"
            end-placeholder="Конец"
            :picker-options="dateOptions"
          )
        el-button(type="primary" @click="loadMoves()" :disabled="isLoading") Запросить
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="moves"
            style="width: 100%; font-size: 12px",
          )
            el-table-column(prop="created" label="Дата" width="200")
            el-table-column(prop="amount" label="Сумма" width="150")
            el-table-column(prop="comment" label="Комментарий" width="150")
            el-table-column(v-if="mode === 'payouts'" prop="account_address" label="Кошелек" width="300")
            el-table-column(v-if="mode === 'payouts'" prop="handler_txid" label="Транзакция" width="300")
              template(slot-scope="scope" )
                a.handler-txid(
                  v-if="scope.row.handler_txid"
                  :href="`https://live.blockcypher.com/btc/tx/${scope.row.handler_txid}/`"
                  target="_blank"
                  ) {{ scope.row.handler_txid }}
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='pagination.count',
            :page-size="per_page",
            :current-page='pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadMoves',
          )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_ACCOUNT_PAYOUTS, LOAD_ACCOUNT_PAYINS, LOAD_ACCOUNTS_NAMES } from "../../store/const/accounts";

export default {
  name: 'MovesList',
  data() {
    return {
      page: 1,
      per_page: 50,
      mode: localStorage.getItem('moves_mode') || 'payouts',
      account_name: '',
      date: '',
      comment: '',
      dateOptions: {
        shortcuts: [{
          text: 'Сегодня',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Сутки',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Вчера',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Месяц',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 месяца',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('accounts', [
      'names',
      'payouts',
      'payins',
    ]),
    isLoading() {
      return this.loading(LOAD_ACCOUNT_PAYOUTS) === 'loading' || this.loading(LOAD_ACCOUNT_PAYINS) === 'loading';
    },
    hasPagination() {
      return this.pagination.count > this.per_page;
    },
    pagination() {
      return this.mode === 'payouts' ? this.payouts.pagination : this.payins.pagination;
    },
    moves() {
      return this.mode === 'payouts' ? this.payouts.list : this.payins.list;
    },
    dates() {
      if (Array.isArray(this.date)) {
        const from = new Date(this.date[0]);
        const to = new Date(this.date[1]);
        from.setMinutes(from.getMinutes() - from.getTimezoneOffset()); // SET TO UTC 0
        to.setMinutes(to.getMinutes() - to.getTimezoneOffset()); // SET TO UTC 0
        from.setMinutes(from.getMinutes() - 180); // SET TO UTC +3
        to.setMinutes(to.getMinutes() - 180); // SET TO UTC +3
        return {
          from: from.getTime(),
          to: to.getTime(),
        }
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.loadNames();
  },
  methods: {
    ...mapActions('accounts', {
      loadNames: LOAD_ACCOUNTS_NAMES,
      loadPayouts: LOAD_ACCOUNT_PAYOUTS,
      loadPayins: LOAD_ACCOUNT_PAYINS,
    }),
    async switchMode() {
      localStorage.setItem('moves_mode', this.mode);
    },
    async loadMoves(page = 1) {
      if (this.isLoading) {
        return;
      }
      if (!this.account_name) {
        return this.$message.warning('Необходимо выбрать пользователя');
      }
      const params = {
        page,
        per_page: this.per_page,
      }
      if (this.dates) {
        params.from = this.dates.from;
        params.to = this.dates.to;
      }
      if (this.comment) {
        params.comment = this.comment.trim();
      }
      if (this.mode === 'payouts') {
        await this.loadPayouts({ name: this.account_name, params });
      } else {
        await this.loadPayins({ name: this.account_name, params });
      }
      this.page = page;
    },
  }
};
</script>
<style>
.filters__container {
  display: flex;
  height: 40px;
  padding: 5px;
  background-color: #efefef;
}
</style>
